import Form from 'app/components/Form';

import {
    createBilling,
    updateBilling
} from 'app/services/billings';

const BillingForm = props => {
    const {
        billing,
        onClose,
        onSubmit,
        action
    } = props;

    let header = null;

    let fields = [
        { name: 'name', label: 'Name', type: 'text', value: billing?.name },
        { name: 'address', label: 'Address', type: 'text', value: billing?.address },
        { name: 'city', label: 'City', type: 'text', value: billing?.city },
        { name: 'state', label: 'State', type: 'text', value: billing?.state },
        { name: 'zip', label: 'Zip', type: 'number', valueType: 'integer', value: billing?.zip },
        { name: 'email', label: 'Email', type: 'text', value: billing?.email }
    ]

    return (
        <Form {...{
            header,
            fields,
            action,
            onClose,
            onSubmit
        }} />
    );
}

export default BillingForm;